<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 99999;">
<div class="quote-loading-container" *ngIf="loading">
  <div class="loading-content">
    <p class="inside">✨</p>
    <img src="../../../../assets/images/home-page-reg-number/logo.png" alt="Loading gear" class="gear-icon" />
     <p class="outside">✨</p>
     <p class="top">✨</p>
    <h3 class="title">Hang tight!</h3>
    <p class="description">
      We're fetching your quote with the<br />
      best available prices from our<br />
      warehouses.
    </p>

    <div class="dots">
    <span class="dot dot1"></span>
    <span class="dot dot2"></span>
    <span class="dot dot3"></span>
  </div>
  </div>
</div>
<div class="quote-card" *ngIf="!loading">
  <h3 class="title">AUTOVERSE</h3>
  <p class="subtitle">Your Magic Quote is Ready!</p>
  <p class="source">Generated from our nearest warehouse</p>

  <div class="quote-info">
    <div> <strong>Quote ID:</strong>{{id}}</div>
    <div><strong>Date: </strong> {{ respose?.created | date: 'dd MMM yyyy'}}</div>
  </div>

  <div class="vehicle-section">
    <div class="section-header">
        <div class="vehicle">
      <i class="material-icons">directions_car</i> Vehicle Information
      </div>
      <i (click)="carDetails(true)" *ngIf="!showCarDetails">expand_more</i>
      <i (click)="carDetails(false)" *ngIf="showCarDetails">expand_less</i>
    </div>
    <div class="vehicle-details" *ngIf="showCarDetails">
      <p ><strong>Registration:</strong> {{ respose.regNo }}</p>
      <p><strong>Vehicle:</strong> {{ respose.make }} {{ respose.model }} |<strong> Variant:</strong> {{ respose.variant }}</p>
      <p><strong>Fuel:</strong> {{ respose.fuelType }} | <strong>Year:</strong> {{ respose.manufacturingYear }}</p>
    </div>
  </div> 

  <div class="delivery-info">
    ⏳ Estimated Delivery 90 MINS
  </div>
<div class="table-total">
<table class="quote-table">
  <thead>
    <tr>
      <th style="width: 8%;">Sr.</th>
      <th>Item</th>
      <th class="align">Rate/Item</th>
      <th class="align" style="width: 8%;">Qty</th>
      <th class="align">Amount</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of itemList; let i = index">
     <tr *ngIf="itemList.length > 0" [class.even]="i % 2 === 1">
      <td style="vertical-align: middle;width: 8%;" >{{ i + 1 }}</td>
      <td>
        <div class="item-name">{{ item?.itemName}}</div>
        <div class="item-brand">{{ item?.brandName }}</div>
        <div class="part-number">{{ item?.partNumber }}</div>
      </td>
      <td class="align" style="color: #4caf50">₹{{  item.sellingPrice }}<br />
        <span class="discount">₹{{ item?.mrp}} (-{{( item?.sellingDiscount) |  number: '1.2-2'}}%)</span>
      </td>
      <td class="align" style="width: 8%;">{{ item.itemQuantity }}</td>
      <td class="align">₹{{ item?.sellingPriceTotal}}</td>
    </tr>
    </ng-container> 
  </tbody>
</table>

 <div class="grand-amount">
  <div class="summary">
      <div class="line-item">
      <h4>Price Details</h4>
    </div>
    <div class="line-item">
      <span>Spare Total:</span> <span><strong>₹{{ getTotalAmount() | number: '1.2-2'}}</strong></span>
    </div>
     <div class="line-item">
      <span>Spare Discount:</span> <span><strong>₹{{ getTotalDiscount()  | number: '1.2-2'}}</strong></span>
    </div>
    <div class="line-item"> 
      <span>Shipping Charges:  <i  class="maticon" mat-raised-button [matTooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()">
     info_outline </i></span> <span><strong>₹{{ shippingCharges | number: '1.2-2'}}</strong></span>
    </div>
    <div class="line-item total">
      <span>Total Payable:</span> <span class="total-amount">₹{{ ((getTotalAmount()- getTotalDiscount() )+ shippingCharges) | number: '1.2-2'}}</span>
    </div>
    <div class="amount-words" *ngIf="shippingCharges">Amount in words: {{ convertNumberToWords( (getTotalAmount()-getTotalDiscount())+ shippingCharges) }}</div>
  </div>
   <ng-template #bottomSheetTemplate >
    <div class="bottom-sheet-content">
        <i class="material-icons" (click)="closeBottomSheet()" style="float: left; cursor: pointer;">cancel</i>
      <h3 style="font-weight: bold;">Shipping Charge</h3>
      <p style="font-size: 13px;">Autoverse provides free Shipping for orders above ₹ {{avoidShippingCharges}}</p>
      <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
    </div>
  </ng-template> 

  <div class="action-buttons">
    <button *ngIf="!hasSalesOrder()" class="place-order" (click)="placeOrderNow()"><i>shopping_cart</i>Place Order Now</button>
    
    <button *ngIf="hasSalesOrder()" class="place-order" (click)="goToOrder()" style="padding: 14px;">🎁 Track Your Order</button>
    <div class="download-share">
      <button (click)="downloadPDF()"><img src="../../../../assets/images/home-page-reg-number/download.png">Download</button>
      <button (click)="shareQuoteOnWhatsApp()"><img src="../../../../assets/images/home-page-reg-number/share.png">Share</button>
    </div>
  </div>
 <div class="pending-box" *ngIf="wrongPartNames.length>0">
  <p style="font-weight: bold;">Hey there 👋</p>

  <p>
    We've included all parts available in our nearest Autoverse warehouse.
  </p>

  <p class="subsection">
    <span class="icon">🛠️</span>
    We are searching for the following items in other locations:
  </p>

  <ul class="item-list"*ngFor="let item of wrongPartNames">
    <li>{{item}}</li>
  </ul>

  <p class="subsection">
    <span class="icon">🕒</span>
    You’ll receive the remaining quote in 30 minutes.
  </p>

  <p>Feel free to go ahead and place your order now! 🚀</p>

  <div class="status-box">
    <p>A new request has been created for the remaining items.</p>
    <div class="request-row">
      <span >Request ID: <strong class="request-id">{{respose?.requestId}}</strong></span>
      <span class="status-badge">
        <img src="../../../../assets/images/home-page-reg-number/pending.png">
        Pending Magic Quote
      </span>
    </div>
  </div>
</div> 

  </div> 
  </div>

  <div class="note">This quote is valid for 24 hours. Prices and availability may vary after this period.</div>








</div>

<div class="invoice-wrapper" id=magicQuote *ngIf="magicQuote">
  <div class="invoice-container">
    <div class="invoice-header">
      <div style="width: 100%; text-align: center;">
        <div class="logo"> <img src="assets/images/logos/mobile_autoverse_logo.svg"  ></div>
        <div class="brand">AUTOVERSE</div>
      </div>
    

    <div class="invoice-meta">
      <div class="address">
        <p>A/4, 3rd Floor, 5TH Block KHB Colony Koramangala, Bengaluru,<br>Bengaluru Urban, Karnataka, 560095</p>
      </div>
      <div class="gst-contact">
        <p>Email: hello&#64;autoversemobility.in<br>Phone: +91 8884998600</p>
      </div>
    </div>

    </div>
    <div class="customer-shipping">
      <div class="box">
        <h4>Customer Details</h4>
        <h5>{{contactName}}</h5>
        <p>{{contactEmail}}</p>
        <p>{{contactPhone}}</p>
      </div>
      <div class="box">
        <h4>Shipping Address</h4>
        <p>{{addresses?.address}}<br> {{addresses?.locality}} {{addresses?.city}},{{addresses?.state}} {{addresses?.country}} {{addresses?.pincode}} </p>
        <p >Vehicle: {{respose.regNo}}</p>
      </div>
    </div>

    <div class="vehicle-number" >{{respose.regNo}}</div>

    <div class="quote-info">
      <div>Quote ID:{{id}}</div>
      <div>Date: {{ respose?.created | date: 'dd MMM yyyy'}}</div>
    </div>

 <table class="quote-table">
  <thead>
    <tr>
      <th>Sr.</th>
      <th>Item</th>
      <th class="align">Rate/Item</th>
      <th class="align">Qty</th>
      <th class="align" style="background: #0F3460;">Amount</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of itemList; let i = index">
     <tr *ngIf="itemList.length > 0" [class.even]="i % 2 === 1">
      <td style="vertical-align: middle;">{{ i + 1 }}</td>
      <td>
       <div class="item-name">{{ item?.itemName}}</div>
        <div class="item-brand">{{ item?.brandName }}</div>
        <div class="part-number">{{ item?.partNumber }}</div>
      </td>
      <td class="align">₹{{item.sellingPrice}}<br />
        <span class="discount">MRP: ₹{{ item?.mrp}} ({{( item?.sellingDiscount ) |  number: '1.2-2'}}% OFF)</span>
      </td>
      <td class="align">{{  item.itemQuantity }}</td>
      <td class="align" style="background: #DBEAFE">₹{{item?.sellingPriceTotal}}</td>
    </tr>
    </ng-container> 
  </tbody>
</table>
<div class="grand-amount" style="width: 100%;">
  <div class="summary" style="background: #F8FAFC;">
      <div class="line-item">
      <h4>Price Details</h4>
    </div>
    <div class="line-item">
      <span>Spare Total:</span> <span><strong>₹{{ getTotalAmount() | number: '1.2-2'}}</strong></span>
    </div>
     <div class="line-item">
      <span>Spare Discount:</span> <span><strong>₹{{ getTotalDiscount() | number: '1.2-2'}}</strong></span>
    </div>
    <div class="line-item">
      <span>Shipping Charges:</span> <span><strong>₹{{ shippingCharges | number: '1.2-2'}}</strong></span>
    </div>
    <div class="line-item total">
      <span>Total Payable:</span> <span >₹{{ ((getTotalAmount()- getTotalDiscount() )+ shippingCharges) | number: '1.2-2'}}</span>
    </div>
    <div class="amount-words" >Amount in words: {{ convertNumberToWords( (getTotalAmount()-getTotalDiscount())+ shippingCharges) }}</div>
  </div>
  </div>

    <div class="disclaimer">
      <strong>Disclaimer:</strong> 
      <p>The quote above is valid for the next 7 days. Terms and conditions apply. Thank you for choosing Autoverse!</p>
    </div>

    <div class="success-box">
      <strong>Your quote has been successfully downloaded! 🎉</strong>
      <p>Your quote is ready and has been downloaded! If you have any questions or need further assistance, </p>
        <p>we’re always here for you. 😊</p>
    </div>
    <div class="help-button">
      <button>Need Assistance? We're here to help! 💬</button>
    </div>
  </div>
</div> 

</div>